import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { SAFETY_QUESTIONS_ACTIONS, SAFETY_QUESTIONS_TYPES } from "./actions";
import {
  getSafetyQuestion as APIgetSafetyQuestion,
  getSafetyQuestions as APIgetSafetyQuestions,
  createSafetyQuestion as APIcreateSafetyQuestion,
  updateSafetyQuestion as APIupdateSafetyQuestion,
  deleteSafetyQuestion as APIdeleteSafetyQuestion
} from "../../services/api/safetyQuestions";
import { navigateTo } from "../navigation/saga";
import { safetyQuestionsEvent, safetyQuestionsFilters } from "./selectors";

export function* watchSafetyQuestionsActions() {
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.LOAD_ALL_REQUEST, getSafetyQuestions)
  ]);
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.LOAD_REQUEST, getSafetyQuestion)
  ]);
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.CREATE_REQUEST, createSafetyQuestion)
  ]);
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.UPDATE_REQUEST, updateSafetyQuestion)
  ]);
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.DELETE_REQUEST, deleteSafetyQuestion)
  ]);
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.CREATE_SUCCESS, getSafetyQuestions)
  ]);
  yield all([
    takeEvery(SAFETY_QUESTIONS_TYPES.DELETE_SUCCESS, getSafetyQuestions)
  ]);
}

function* getSafetyQuestions(action) {
  let { filters, eventId } = action.payload;

  try {
    if (filters) {
      yield put(SAFETY_QUESTIONS_ACTIONS.updateFilters(filters));
    } else {
      filters = yield select(safetyQuestionsFilters);
    }

    eventId = yield call(checkEventId, eventId);

    const safetyQuestions = yield call(APIgetSafetyQuestions, eventId, filters);
    yield put(SAFETY_QUESTIONS_ACTIONS.loadAllSuccess(safetyQuestions));
  } catch (e) {
    yield put(SAFETY_QUESTIONS_ACTIONS.loadAllFailure(e));
  }
}

function* getSafetyQuestion(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const safetyQuestion = yield call(APIgetSafetyQuestion, eventId, id);
    yield put(SAFETY_QUESTIONS_ACTIONS.loadSuccess(safetyQuestion));
  } catch (e) {
    yield put(SAFETY_QUESTIONS_ACTIONS.loadFailure(e));
  }
}

function* createSafetyQuestion(action) {
  const { values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const safetyQuestion = yield call(APIcreateSafetyQuestion, eventId, values);
    yield put(SAFETY_QUESTIONS_ACTIONS.createSuccess(safetyQuestion));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/safety-questions"
    );
  } catch (e) {
    yield put(SAFETY_QUESTIONS_ACTIONS.createFailure(e));
  }
}

function* updateSafetyQuestion(action) {
  const { id, values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const safetyQuestion = yield call(
      APIupdateSafetyQuestion,
      eventId,
      id,
      values
    );
    yield put(SAFETY_QUESTIONS_ACTIONS.updateSuccess(safetyQuestion));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/safety-questions"
    );
  } catch (e) {
    yield put(SAFETY_QUESTIONS_ACTIONS.updateFailure(e));
  }
}

function* deleteSafetyQuestion(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const safetyQuestion = yield call(APIdeleteSafetyQuestion, eventId, id);
    yield put(SAFETY_QUESTIONS_ACTIONS.deleteSuccess(safetyQuestion));
  } catch (e) {
    yield put(SAFETY_QUESTIONS_ACTIONS.deleteFailure(e));
  }
}

function* checkEventId(eventId) {
  if (eventId) {
    yield put(SAFETY_QUESTIONS_ACTIONS.updateEvent(eventId));
  } else {
    eventId = yield select(safetyQuestionsEvent);
  }

  return eventId;
}
